import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from '../constants/constants';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';
import { ScormEntry } from '../_models/ScormEntry';

@Injectable({
  providedIn: 'root'
})
export class ScormEntryService {
  private baseUrl: string = this.config.protectedResourceEndpoint;

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) { }

  public addScormEntry$(scormEntry: ScormEntry) {
    return this.http.post(this.baseUrl + AppConstants.SCORM_ENTRY, scormEntry);
  }
}
